import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Payment } from './payment.model';
import { Invoice } from '../invoice';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class PaymentService extends AbstractEntityService {

    protected resourceUrl = 'api/payments';
    private resourceSearchUrl = 'api/_search/payments';
    protected resourceCountUrl = 'api/_search/count/payments';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(payment: Payment): Observable<Payment> {
        let copy: Payment = Object.assign({}, payment);
        copy.paymentDate = this.dateUtils
            .convertLocalDateToServer(payment.paymentDate);
        return this.http.post<Payment>(this.resourceUrl, copy).map((res: Payment) => {
            return res;
        });
    }

    update(payment: Payment): Observable<Payment> {
        let copy: Payment = Object.assign({}, payment);
        copy.paymentDate = this.dateUtils
            .convertLocalDateToServer(payment.paymentDate);
        return this.http.put<Payment>(this.resourceUrl, copy).map((res: Payment) => {
            return res;
        });
    }

    find(id: number): Observable<Payment> {
        return this.http.get<Payment>(`${this.resourceUrl}/${id}`).map((res: Payment) => {
            let jsonResponse = res;
            jsonResponse.paymentDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.paymentDate);
            return jsonResponse;
        });
    }

    getVirtualInvoiceForPayment(paymentId: number, taxRate?: number, dateIssued?: Date): Observable<Invoice> {
        let dateIssuedParam: string  = dateIssued && ( dateIssued instanceof Date) ? dateIssued.getFullYear() + '-'
        + dateIssued.getMonth() + '-' + dateIssued.getDate() : null; // LocalDate as ISO String (YYYY-MM-DD)

        let taxRateParam: string = taxRate != null ? taxRate.toString() : null; // Convert BigDecimal to String

        let params = new HttpParams();

        if (paymentId) {
            params = params.set('paymentId', paymentId.toString());
        }
        if (taxRateParam) {
            params = params.set('taxRate', taxRateParam);
        }
        if (dateIssuedParam) {
            params = params.set('dateIssued', dateIssuedParam);
        }

        return this.http.get<Payment>(`${this.resourceUrl}/virtual-invoice`, { params }).map((res: Invoice) => {
            let jsonResponse = res;
            jsonResponse.dateIssued = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateIssued);
            jsonResponse.dueDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dueDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<Payment[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Payment[]>>(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
            ;
    }

    search(req?: any): Observable<HttpResponse<Payment[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Payment[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<Payment[]>) => this.convertResponse(res))
            ;
    }

    private convertResponse(res: HttpResponse<Payment[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].paymentDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].paymentDate);
        }
        return res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment/payment.service.ts